
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ExportLogsSuccessModal',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showExportLogsSuccessModal: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    viewerEmail: {
      type: String,
      required: true
    }
  },
  computed: {
    disablePrimaryAction() {
      return this.loading || this.disabled
    }
  }
})
